export const WorkData = [
  {
    company: 'IAG: Vueling',
    designation: 'Data Analyst',
    dateJoining: 'Nov 2023',
    dateEnd: 'May 2024',
    companyLogo:
      'https://upload.wikimedia.org/wikipedia/commons/b/b8/Logo_Vueling.svg',
    work: '-Extracted data from APIs using Python and R to transform it and visualise it, which reduced time preparing daily presentations by 50%\n -Streamlined data exploration and visualization by leveraging Salesforce API (SOQL) through Tableau, significantly reducing elaboration time.\n -Addressed diverse data requests and actively monitored KPIs across various customer care departments, including social media, contact centers, quality auditing, and disruption coordination.',
  },
  {
    company: 'IAG: IAG Loyalty',
    designation: 'Associate Software Engineer',
    dateJoining: 'Mar 2023',
    dateEnd: 'Nov 2023',
    companyLogo:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFhAjjaUTSWqlkBzqGOzitrhnW3h1rS-3S6TBy36pUDA&s',
    work: '- Contributed to the development of the rewards web app using React, Typescript, Express.js. \n - Consistently engaged in diverse areas such as Google Analytics, A/B testing (Devcycle), content management (Contentful), styling of the UI (Storybook), Datadog, backend tickets, etc. \n - Actively participated in pair programming, reviewing code, and conducting code demos and presentations in sprint reviews.',
  },
  {
    company: 'Public Health Scotland (NHS)',
    designation: 'Information Analyst',
    dateJoining: 'Aug 2021',
    dateEnd: 'Oct 2022',
    companyLogo: 'https://publichealthscotland.scot/images/phs-logo.png',
    work: '- Produced automated reports and ad-hoc analyses using R (data wrangling and visualisation with tidyverse, parameterised and interactive reports with RMarkdown, geospatial analysis with leaflet), SQL, Tableau and Excel.  \n - Liaised with clinicians, academics and project managers to track key performance metrics.',
  },
  {
    company: 'Indepen-dance',
    designation: 'Monitoring and Evaluation Intern & Freelancer',
    dateJoining: 'Nov 2020',
    dateEnd: 'Jun 2021',
    companyLogo:
      'https://www.indepen-dance.org.uk/wp-content/uploads/2020/02/indepen-dance-logo-main-w-strap.png',
    work: '- Quantitative and qualitative data collection, analysis and presentation (Zoom attendance data, Youtube analytics, surveys, focus groups, demographic information).  \n - Assisted with funding applications showing impact data.  \n - Developed an evaluation plan to streamline the collection and analysis of impact data.',
  },
];
